export default __webpack_public_path__ + "static/media/resume.f7e10851.png";